import classNames from "components/ui/classNames";
import type { ReactNode } from "react";

interface IContentContainerProps {
  children: ReactNode;
  className?: string;
}

export default function ContentContainer({ children, className, ...props }: IContentContainerProps) {
  return (
    <div className={classNames("relative rounded-xl border border-slate-200 bg-white p-1", className)} {...props}>
      {children}
    </div>
  );
}
